import React from 'react';

import SearchEventsSaved from '../../searches/SearchEventsSaved';
import CTA from '@molecules/CTA';
import { DivWithShadowMediumUp, H4 } from '@styled';

const SavedEvents = () => (
    <div>
        <H4 className="mb-1.5rem">Saved Events</H4>

        <DivWithShadowMediumUp>
            <div className="mb-2rem">
                <CTA headerText="These are the events you've saved." showLarge />
            </div>

            <SearchEventsSaved
                NoResultsText={() => (
                    <>Looks like there are no saved events yet. Explore your recommended events above.</>
                )}
            />
        </DivWithShadowMediumUp>
    </div>
);

export default SavedEvents;
